/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Actions from './Actions/index'
import EditableTextArea from 'DesignSystem/EditableTextArea/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Content/Content/HtmlFile/Content/Content/Content/Content"
  
}) {
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let editorDisabledValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'disabled',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let contentValueData = fromData.useDataValue({ viewPath,
context: 'content',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsNeutral100,'--pt-2-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-5-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical}`}
>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--btc-6-Z1Yf8zk': dtColorsNeutral300,'--blc-7-Z1Yf8zk': dtColorsNeutral300,'--brc-8-Z1Yf8zk': dtColorsNeutral300,'--btlr-9-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--btrr-10-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--o-11-Z1Yf8zk': editorDisabledValueData ? 0.5 : 1}}
 className={`views-block ${styles.Vertical1}`}
>
<EditableTextArea
  viewPath={`${viewPath}/EditableTextArea`}
 data="content"
 value={contentValueData}
 onChange={onChange}
/>
</div>
</div>
{children}
</React.Fragment>)
}